import React , {useEffect} from "react";
import { GetProfileImages } from "../../Containers/DocumentDetails/slice";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import CardActionArea from "@mui/material/CardActionArea";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import InfoIcon from "@mui/icons-material/Info";
import Drawer from "@mui/material/Drawer";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import Stack from "@mui/material/Stack";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import Button from "@mui/material/Button";
import SvgIconStyle from "../SvgIconStyle";
import dayjs from "dayjs";
import TextField from "@mui/material/TextField";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/pt";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { green } from "@mui/material/colors";
import {
  CollectionStatus,
  ComponentType,
  DonationStatus,
  EntityType,
  RegistrationStatus,
  isCAActive
} from "../../common/enum";
import { Divider, Grid, Tooltip } from "@mui/material";
import CollectionDonationProductCard from "./CollectionDonationProductCard";
import { useDispatch, useSelector } from "react-redux";
import {
  addCollection,
  addCollectionQuantity,
  updateCollection,
} from "../../Containers/CreateCollection/slice";
import {
  setSnackbarMessage,
  setSnackbarOpen,
  setSnackbarSeverity,
} from "../../Containers/AdminView/adminSlice";
import { getMyActiveDonation } from "../../Containers/DashBoardView/slice";
import { PRODUCT_ICON } from "../../common/enum/productIcon";
import CollectionProducts from "./CollectionProducts";
import CollectionProductsEventos from "./CollectionProductsEventos"
import DirectionsOutlinedIcon from "@mui/icons-material/DirectionsOutlined";
// import { getDistance ,getPreciseDistance,convertDistance} from "geolib";
import StarIcon from "@mui/icons-material/Star";
import MapLeaflet from "../../Containers/MapLeaflet/MapLeaflet";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import L from "leaflet";
import FavoriteIcon from "@mui/icons-material/Star";
import { useSnackbar } from "notistack";
import { getCollectorInviteForDonation } from "../../Containers/CollectorInvitation/slice";
import "./styles.css";
import { Style } from "@mui/icons-material";
import styled from "@emotion/styled";
const ICON = [
  {
    productGroup: "Frescos",
    url: "/static/icons/Icons/icon-frescos.png",
  },
  {
    productGroup: "Congelados",
    url: "/static/icons/Icons/icon-congelados.png",
  },
  {
    productGroup: "Mercearia",
    url: "/static/icons/Icons/icon-mercearia.png",
  },
  {
    productGroup: "Laticínios, cremes vegetais e ovos",
    url: "/static/icons/Icons/icon-lacticinios.png",
  },
  {
    productGroup: "Bebidas",
    url: "/static/icons/Icons/icon-bebidas.png",
  },
  {
    productGroup: "Refeições prontas",
    url: "/static/icons/Icons/icon-refeicoesprontas.png",
  },
];

const DONATION_STATUS = [
  {
    status: "RESERVED",
    statusValue: "Reserva total",
    color: "#E36300",
    bgColor: "#FFE5C4",
  },
  {
    status: "PARTIAL",
    statusValue: "Reserva parcial",
    color: "#EE9500",
    bgColor: "#FFFBD4",
  },
  {
    status: "CANCELLED",
    statusValue: "Cancelado",
    color: "#DC2600",
    bgColor: "#FFE2E2",
  },
];
function toLocalISOString(inputDate) {
  const date = inputDate instanceof Date ? inputDate : new Date(inputDate);

  if (isNaN(date)) {
    throw new Error('Invalid date');
  }

  const offsetMs = date.getTimezoneOffset() * 60000;
  const adjustedDate = new Date(date.getTime() - offsetMs);
  return adjustedDate.toISOString().slice(0, -1);
}
const CustomStatus = ({ color, status, bgColor }) => (
  <Box
    sx={{
      border: `1px solid ${color}`,
      borderRadius: "10px",
      backgroundColor: `${bgColor}`,
      // opacity: 0.5,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      padding: 1,
    }}
  >
    <InfoIcon
      sx={{
        backgroundColor: `${color}`,
        color: "white",
        width: 32,
        height: 32,
        padding: 0.5,
        borderRadius: "10px",
      }}
    />
    <Typography
      variant="body1"
      sx={{
        pl: 1,
        textTransform: "capitalize",
        fontWeight: 600,
        fontSize: "14px",
        overflow: "hidden",
        whiteSpace: "nowrap",
      }}
      fontFamily={"Poppins"}
    >
      {status}
    </Typography>
  </Box>
);

const CollectionDonationCard = ({ t, item , selectDistrict, selectCounty , distanceFilterCheck}) => {
  const COVER_URL = "/static/illustrations/illustration_default_banner.jpg";
  const AVATAR_URL = "/static/illustrations/illustration_defaultavatar.png";
  const {
    auth: {
      user: { userId, entityId ,status},
      profile: { entity, address, favoriteProducts },
    },
    dashboardInfo: { myActiveDonationsOffSet, myActiveDonationsLimit, entityProfileSelect },
  } = useSelector((state) => state);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [drawerState, setDrawerState] = React.useState(false);
  const [dateWithInitialValue, setDateWithInitialValue] = React.useState(null);
  const [currentError, setCurrentError] = React.useState(null);
  const [errorProduct, setErrorProduct] = React.useState(false);
  const [errorDate, setErrorDate] = React.useState(false);
  const [collectionProduct, setCollectionProduct] = React.useState([]);
  const [mapOpen, setMapOpen] = React.useState(false);
  const [position, setPosition] = React.useState(null);
  const [selectProductError, setSelectProductError] = React.useState(false);
  const setMarkPosition = (value) => {
    setPosition(value);
  };
 
  const [isInvited, setIsInvited] = React.useState(false);

  const toggleDrawer = (value) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
   // setCollectionProduct([]);
    setDrawerState(value);
  };
  const expiredDate = React.useMemo(() => {
    const date = new Date(item?.donation.expiryDate); // No "Z"
    
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hour = date.getHours().toString().padStart(2, '0');
    const minute = date.getMinutes().toString().padStart(2, '0');
  
    const formattedDate = `${day}/${month}/${year} ${hour}:${minute}`;
    return formattedDate;
  }, [item?.donation.expiryDate]);

  const StartDate = React.useMemo(() => {
    const date = new Date(item?.donation.availableFromDate);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hour = date.getHours().toString().padStart(2, '0');
    const minute = date.getMinutes().toString().padStart(2, '0');
  
    const formattedDate = `${day}/${month}/${year} ${hour}:${minute}`;
    return formattedDate;
  }, []);

  const isAvailableFprSpecialReceiver = React.useMemo(() => {
    return !!(
      item?.donation.isAnimal &&
      new Date().getTime() > new Date(item?.donation.expiryDate).getTime()
    );
  }, [item?.donation.isAnimal, item?.donation.expiryDate]);

  React.useEffect(() => {
    const data = {
      donationId: item.donation.donationId,
    };
    dispatch(getCollectorInviteForDonation(data))
      .unwrap()
      .then((res) => {
        if (res.invites.find((i) => i.collectorEntityId === entity?.entityId)) {
          setIsInvited(true);
        } else {
          setIsInvited(false);
        }
      })
      .catch((e) => {
        setIsInvited(false);
      });
  }, [item]);

  const isFavorite = React.useMemo(() => {
    return (
      favoriteProducts.filter((p) =>
        item.donationProducts.find(
          (pr) => pr.productId.toString() === p.productId
        )
      ).length > 0
    );
  }, [favoriteProducts, item.donationProducts]);

 

  const myCategory = React.useMemo(() => {
    const payload = [];
    item.donationProducts.forEach((product) => {
      payload.push(
        product.productType ? product.productType : product.productGroup
      );
    });
    return payload;
  }, [item]);

  const filterIcon = React.useMemo(() => {
    return PRODUCT_ICON.filter((obj) =>
      item?.donationProducts.some((ob) => ob.productGroup === obj.productGroup)
    );
  }, [item, PRODUCT_ICON]);

  // const setCollection = React.useCallback(
  //   (value) => {
  //     const collectionProductIds =
  //       collectionProduct.length > 0
  //         ? collectionProduct.map((val) => val.donationProductId)
  //         : [];
  //     if (collectionProductIds.includes(value.donationProductId)) {
  //       const arr = collectionProduct.filter(
  //         (donationPro) =>
  //           donationPro.donationProductId !== value.donationProductId
  //       );
  //       if (value.quantity === 0) {
  //         // collectionProduct = [...arr]
  //         setCollectionProduct([...arr])
  //       } else {
  //         // collectionProduct = [...arr, value]
  //         setCollectionProduct([...arr, value])
  //       }
  //     } else {
  //       // collectionProduct = [...collectionProduct, value];
  //       setCollectionProduct([...collectionProduct, value])
  //     }
  //   },
  //   [collectionProduct]
  // );
const setCollection = React.useCallback((value) => {
  setCollectionProduct((prevCollection) => {
    const collectionProductIds = prevCollection.map(
      (val) => val.donationProductId
    );

    if (collectionProductIds.includes(value.donationProductId)) {
      const arr = prevCollection.filter(
        (donationPro) =>
          donationPro.donationProductId !== value.donationProductId
      );

      if (value.quantity === 0) {
        return [...arr];
      } else {
        return [...arr, value];
      }
    } else {
      return [...prevCollection, value];
    }
  });
}, [collectionProduct]);

  const setProductError = React.useCallback((value) => {
    setErrorProduct(value);
  }, []);

  const clearCollectionProduct = React.useCallback(() => {
    // collectionProduct = []
    setCollectionProduct([])
    setDateWithInitialValue(null);
    setErrorDate(false);
    setErrorProduct(false);
  }, []);

  const distance = React.useMemo(() => {
    if (item?.addresses?.length > 0) {
      const isLat = isNaN(Number(address[0]?.latitude));
      const isLng = isNaN(Number(address[0]?.longitude));
      const isItemLng = isNaN(Number(item.addresses[0]?.longitude));
      const isItemLat = isNaN(Number(item.addresses[0]?.latitude));
      if (!isLat && !isLng && !isItemLat && !isItemLng) {
        let latlng1 = L.latLng(
          Number(address[0]?.latitude),
          Number(address[0]?.longitude)
        );
        let latlng2 = L.latLng(
          Number(item.addresses[0]?.latitude),
          Number(item.addresses[0]?.longitude)
        );

        let d = latlng1.distanceTo(latlng2) / 1000;
        return d;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }, [item]);
 
  const submitCollection = React.useCallback(async () => {
    var dataErrada = false;
    var filterquantidade = collectionProduct.filter(product => product.quantity === 0)
    if (collectionProduct.length === 0 && !item?.donation.isEvent || filterquantidade.length > 0) {
      setSelectProductError(true);
    } else {
      if(item.donation.isAnimal == false && new Date(item.donation.availableFromDate) > new Date(dateWithInitialValue)){
        setErrorDate(true);
        setCurrentError(t("selectDate"));
        dataErrada = true
      }else if(isAvailableFprSpecialReceiver == false && item.donation.isAnimal == true && new Date(item.donation.availableFromDate) > new Date(dateWithInitialValue) ){
        setErrorDate(true);
        setCurrentError(t("selectDate"));
        dataErrada = true
      }else if(isAvailableFprSpecialReceiver ==  true && item.donation.isAnimal == true && new Date(item.donation.expiryDate) > new Date(dateWithInitialValue)){
        setErrorDate(true);
        setCurrentError(t("selectDate"));
        dataErrada = true
      }
      if (
        dateWithInitialValue !== null &&
        errorDate === false  && 
        dataErrada == false
        //errorProduct === false
      ) {
        setSelectProductError(false);
        const collectionPayload = {
          donationId: item.donation.donationId,
          dateOfCollection: dateWithInitialValue,
          collectionAddressId: item.addresses[0].addressId, // same entity address
          collectorId: entity?.entityId, //userId
          collectionStatus: CollectionStatus.creating,
          createdBy: entity?.entityId, //userId
        };
        await dispatch(addCollection(collectionPayload))
          .unwrap()
          .then((response) => {
            Promise.all(
              collectionProduct.map((data) => {
                data["collectionId"] = response.collection.id;
                return dispatch(addCollectionQuantity(data));
              })
            )
              .then((res) => {
                const payload = {
                  collectionId: response.collection.id,
                  status: CollectionStatus.reserved,
                  dateOfCollection: dateWithInitialValue,
                  updatedBy: entity?.entityId,
                  addressId: "",
                };
                dispatch(updateCollection(payload))
                  .unwrap()
                  .then(() => {
                   
                      const data2 = {
                        offset: myActiveDonationsOffSet,
                        limit: myActiveDonationsLimit,
                        entityType: entityProfileSelect!= "" && entityProfileSelect!= null && entityProfileSelect != undefined? entityProfileSelect : entity.entityType,
                        entityId: entity?.entityId,
                      };
                        // data["status"] = status;
                        // data["isAnimal"] = isAnimal;
                      
                    // const data = {
                    //   offset: myActiveDonationsOffSet,
                    //   limit: myActiveDonationsLimit,
                    //   // status: DonationStatus.new,
                    // };
                    dispatch(getMyActiveDonation(data2));
                    setCollectionProduct([]);
                    enqueueSnackbar({
                      message: t("Reserva criada com sucesso"),
                      variant: "success",
                    });
                    setDrawerState(false);
                  })
                  .catch((error) => {
                    enqueueSnackbar({
                      message: t("Não foi possível criar uma reserva"),
                      variant: "error",
                    });
                    enqueueSnackbar({
                      message: t("Não foi possível criar uma reserva"),
                      variant: "error",
                    });
                  });
              })
              .catch((error) => {
                enqueueSnackbar({
                  message: t("Não foi possível criar uma reserva"),
                  variant: "error",
                });
              });
          })
          .catch((err) => {
            enqueueSnackbar({
              message: t("Não foi possível criar uma reserva"),
              variant: "error",
            });
          });
      } else {
        setErrorDate(true);
        setCurrentError(t("selectDate"));
      }
    }
  }, [dateWithInitialValue, dispatch]);

  const handleClick = React.useCallback(() => {
    if (mapOpen) {
      setMapOpen(false);
    } else {
      setDrawerState(false);
    }
  }, [mapOpen]);

  const replaceImage = (error) => {
    error.target.src = COVER_URL;
  };

  const replaceAvatar = (error) => {
    error.target.src = AVATAR_URL;
  };
  //console.log("collection donation")

  const [entitybanneruri, setentitybanneruri] = React.useState("");
  const [profilepictureuri, setprofilepictureuri] = React.useState("");

  useEffect(() => {
  const loadImages = async () => {
    try {
      const banner = item?.entityLeastDetails?.bannerImage;
      const profile = item?.entityLeastDetails?.profilePicture;

      if (banner && banner !== "string") {
        const response = await dispatch(GetProfileImages(banner)).unwrap();
        setentitybanneruri(response?.isActive ?? COVER_URL);
      } else {
        setentitybanneruri(COVER_URL);
      }

      if (profile && profile !== "string") {
        const response = await dispatch(GetProfileImages(profile)).unwrap();
        setprofilepictureuri(response?.isActive ?? AVATAR_URL);
      } else {
        setprofilepictureuri(AVATAR_URL);
      }
    } catch (err) {
      console.error("Erro ao carregar imagens:", err);
      // Em caso de erro genérico, usar URLs de fallback
      setentitybanneruri(COVER_URL);
      setprofilepictureuri(AVATAR_URL);
    }
  };

  loadImages();
}, [item]);
 
  return (
   
    
    <React.Fragment>
     {
        <Card 
        
	  
        // {...item?.donation.status == "RESERVED" ? {className: "RESERVEDcolor"} : item?.donation.isEvent == true ? {className:"isEventbackground"} : {className:"NotRESERVATED"}} sx={{ width: 1}}
        {...item?.donation.isEvent == true ? {className:"isEventbackground"} : item?.donation.status == "RESERVED" ? {className: "RESERVEDcolor"} : {className:"NotRESERVATED"} } sx={{ width: 1}} >
        <CardActionArea
          sx={{ display: "flex", width: 1, justifyContent: "flex-start" }}
          onClick={toggleDrawer(true)}
        >
          <Box
            sx={{
              // backgroundImage: `url(${
              //   item?.entityLeastDetails?.bannerImage === null ||
              //   item?.entityLeastDetails?.bannerImage === "string"
              //     ? COVER_URL
              //     : item?.entityLeastDetails?.bannerImage
              // })`,

              position: "relative",

              m: 1,
              // borderRadius: "10px",
            }}
          >
            <CardMedia
              src={
                item?.entityLeastDetails?.bannerImage === null ||
                item?.entityLeastDetails?.bannerImage === "string"
                  ? COVER_URL
                  : entitybanneruri
              }
              alt={"Banner"}
              component={"img"}
              onError={replaceImage}
              sx={{
                height: 220,
                width: 100,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                borderRadius: "10px",
              }}
            />
            <Box
              sx={{
                borderRadius: "10px",
                position: "absolute",
                width: "100%",
                height: "100%",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                bgcolor: "rgba(0, 0, 0, 0.54)",
                color: "white",
                padding: "10px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Avatar
                alt={item?.entityLeastDetails?.entityName}
                src={
                  item?.entityLeastDetails?.profilePicture === "string" ||
                  item?.entityLeastDetails?.profilePicture === null
                    ? AVATAR_URL
                    : profilepictureuri
                }
                onError={replaceImage}
                sx={{
                  bgcolor: green[500],
                  width: 56,
                  height: 56,
                  margin: "0px auto",
                  "& img": {
                    height:
                      item?.entityLeastDetails?.profilePicture === "string" ||
                      item?.entityLeastDetails?.profilePicture === null
                        ? "100%"
                        : "100%",
                    width:
                      item?.entityLeastDetails?.profilePicture === "string" ||
                      item?.entityLeastDetails?.profilePicture === null
                        ? "100%"
                        : "100%",
                  },
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                }}
              >
                {filterIcon?.length > 0 &&
                  !item?.donation.isEvent &&
                  filterIcon.map((itemImage) => (
                    <Tooltip
                      title={itemImage?.productGroup}
                      arrow
                      key={itemImage?.productGroup}
                    >
                      <Avatar
                        alt={itemImage?.productGroup}
                        src={itemImage?.url}
                        sx={{
                          width: 24,
                          height: 24,
                          mb: 0.5,
                          ml: 0.2,
                        }}
                      />
                    </Tooltip>
                  ))}
                {filterIcon?.length === 0 &&
                  item?.donation.isEvent === true && (
                    <Tooltip title={"Evento"} arrow>
                      <Avatar
                        alt={"evento"}
                        src={"/static/icons/Icons/icon-event.png"}
                        sx={{
                          width: 24,
                          height: 24,
                          mb: 0.5,
                          ml: 0.2,
                        }}
                      />
                    </Tooltip>
                  )}
              </Box>
            </Box>
          </Box>

          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              p: 1,
              height: 220,
              width: "65%",
            }}
          >
            {/* entityLeastDetails */}
            <Box sx={{ width: 1 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  fontFamily={"Poppins"}
                >
                  {distance.toFixed(2)} km
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {isFavorite && <FavoriteIcon color={"warning"} />}
                  {isInvited && (
                    <Avatar
                      alt={""}
                      src={"/static/icons/icon-entidadebeneficiaria.svg"}
                      sx={{
                        width: 20,
                        height: 20,
                        ml: 0.5,
                      }}
                    />
                  )}
                </Box>
              </Box>
              <Typography
                variant="h6"
                component="h6"
                fontSize={"16px"}
                fontWeight={600}
                fontFamily={"Poppins"}
              >
                {item?.entityLeastDetails?.entityName != null ? item?.entityLeastDetails?.entityName : entity?.entityName}
                {/* {item?.addresses && item.addresses[0].isHeadquarter == true ? item?.entityLeastDetails?.entityName : item.addresses[0].addressTitle} */}
              </Typography>
              {item?.donation.consumeByDate &&  new Date(item?.donation.expiryDate) < new Date() ? 
              <Typography
                variant="body2"
                color="text.secondary"
                fontSize={"small"}
                fontFamily={"Poppins"}
              >
                {t("in")}{" "}
                <span>
                  {new Date(
                    item?.donation.expiryDate
                  ).toLocaleString("pt", {
                    day: "numeric",
                    month: "numeric",
                    year: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    formatMatcher: "best fit",
                  })}
                </span>{" "}
                {t("until")}{" "}
                <span>
                {new Date(
                    item?.donation.consumeByDate
                  ).toLocaleString("pt", {
                    day: "numeric",
                    month: "numeric",
                    year: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    formatMatcher: "best fit",
                  })}
                </span>
              </Typography>
              : <Typography
              variant="body2"
              color="text.secondary"
              fontSize={"small"}
              fontFamily={"Poppins"}
            >
              {t("in")}{" "}
              <span>
                {new Date(
                  item?.donation.availableFromDate
                ).toLocaleString("pt", {
                  day: "numeric",
                  month: "numeric",
                  year: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                  formatMatcher: "best fit",
                })}
              </span>{" "}
              {t("until")}{" "}
              <span>
              {new Date(
                  item?.donation.expiryDate
                ).toLocaleString("pt", {
                  day: "numeric",
                  month: "numeric",
                  year: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                  formatMatcher: "best fit",
                })}
              </span>
            </Typography>}
            </Box>
            {(item?.donation.isEvent == false && item?.donation.status === DonationStatus.reserved ||
              item?.donation.isEvent == false && item?.donation.status === DonationStatus.partial ||
              item?.donation.status === DonationStatus.cancel) && (
              <CustomStatus
                color={
                  DONATION_STATUS.find(
                    (donation) => donation.status === item?.donation.status
                  ).color
                }
                status={
                  DONATION_STATUS.find(
                    (donation) => donation.status === item?.donation.status
                  ).statusValue
                }
                bgColor={
                  DONATION_STATUS.find(
                    (donation) => donation.status === item?.donation.status
                  ).bgColor
                }
              />
            )}
            <Box sx={{ display: "flex", flexWrap: "wrap", maxWidth: "300px" }}>
              {myCategory?.slice(0, 1).map((cat, index) => (
                <Chip
                  sx={{
                    backgroundColor: "#E4F2E8",
                    color: "#1B727E",
                    my: "5px",
                    mr: "5px",
                    maxWidth: "100px !important",
                    "& .MuiChip-label": {
                      fontWeight: 600,
                      fontFamily: "Poppins",
                    },
                  }}
                  label={t(cat)}
                  size={"medium"}
                  component="div"
                  key={index}
                />
              ))}
              {myCategory !== undefined && myCategory.length > 1 && (
                 
                <Tooltip title={myCategory?.slice(1).join(" , ")}>
                <Chip
                  sx={{
                    backgroundColor: "#E4F2E8",
                    color: "#1B727E",
                    my: "5px",
                    mr: "5px",
                    maxWidth: "100px !important",
                    "& .MuiChip-root": {
                      maxWidth: "100px",
                    },
                    "& .MuiChip-label": {
                      fontWeight: 600,
                      fontFamily: "Poppins",
                    },
                  }}
                  label={`+${myCategory.length - 1}`}
                  size={"medium"}
                  
                />
                </Tooltip>
              )}
            </Box>
          </CardContent>
        </CardActionArea>
      </Card>}
      <Drawer
        anchor={"right"}
        open={drawerState}
        onClose={() => {
          toggleDrawer(false);
          setMapOpen(false);
        }}
        PaperProps={{
          sx: {
            width: "50%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          },
        }}
      >
        <Button
          sx={{
            position: "fixed",
            right: "51%",
            top: 10,
            zIndex: 1,
            minWidth: 0,
            borderRadius: "4px",
            padding: "4px",
            backgroundColor: mapOpen ? "#e1efb0" : "#ffc3c3",
            "&:hover": {
              backgroundColor: mapOpen ? "#e1efb0" : "#ffc3c3",
            },
            "@media (max-width:900px)": {
              right: "1%",
            },
          }}
          onClick={handleClick}
        >
          {mapOpen ? (
            <ArrowBackOutlinedIcon color="primary" />
          ) : (
            <CloseOutlinedIcon color="error" />
          )}
        </Button>
        {!mapOpen && (
          <>
            <Box
              sx={{
                height: "110px",
                backgroundImage: `url(${
                  item?.entityLeastDetails?.bannerImage === null ||
                  item?.entityLeastDetails?.bannerImage === "string"
                    ? COVER_URL
                    : entitybanneruri
                }),url(${COVER_URL})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                position: "relative",
              }}
            >
              <Box
                sx={{
                  // position: "absolute",
                  width: "100%",
                  height: "110px",
                  bgcolor: "rgba(0, 0, 0, 0.54)",
                  // display: "flex",
                  // justifyContent: "flex-start",
                }}
              >
                <Avatar
                  alt="Profile picture"
                  src={
                    item?.entityLeastDetails?.profilePicture === "string" ||
                    item?.entityLeastDetails?.profilePicture === null
                      ? AVATAR_URL
                      : profilepictureuri
                  }
                  onError={replaceAvatar}
                  sx={{
                    position: "absolute",
                    backgroundColor: "green",
                    margin: "0 30px",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    borderRadius: "50%",
                    width: "100px",
                    height: "100px",
                    transform:
                      "translateY(50%)" /* additional 50% of own height */,
                    boxShadow: "0 0 0 10px #fff",
                    "& img": {
                      height:
                        item?.entityLeastDetails?.profilePicture === "string" ||
                        item?.entityLeastDetails?.profilePicture === null
                          ? "100%"
                          : "100%",
                      width:
                        item?.entityLeastDetails?.profilePicture === "string" ||
                        item?.entityLeastDetails?.profilePicture === null
                          ? "100%"
                          : "100%",
                    },
                  }}
                />
                <Box>
                <Typography
                  variant="h6"
                  sx={{
                    position: "absolute",
                    color: "white",
                    //left: "20%",
                    left: "150px",
                    right: "0",
                    bottom: "40%",
                    fontSize: "1.50rem!important",
                    "@media (max-width:900px)": {
                      //left: "40%",
                      left: "150px"
                    },
                  }}
                >
                  {item?.entityLeastDetails?.entityName != null ? item?.entityLeastDetails?.entityName : entity?.entityName}
                </Typography>
                <Typography
                sx={{
                  position: "absolute",
                  color: "white",
                  left: "150px",
                  right: "0",
                  bottom: "15px",
                
                  fontFamily: "Poppins",
                  fontSize: "1rem!important",
                  "@media (max-width:1280px)": {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "inline-block",
                    width: "90%",
                    whiteSpace: "nowrap",
                  },
                }}
              >
              {" "}
            {<span title={`Código de doação`}>#{`${new Date(
              item?.donation?.createdDate
              ).getFullYear()}${item?.donation.id}`}</span>}
          </Typography>
                </Box>
                
              </Box>
            </Box>
            <Box sx={{ mt: 9, p: 2 }}>
            {item?.donation?.status == 'CANCELLED' &&
             <Box 
             sx={{
               backgroundColor: `#FFE2E2`,
               display: "flex",
               borderRadius: 1.5,
               padding: '8px',
               width: 1,
               alignItems: "center" ,
               mb: 3,
               border: '1px solid #DC2600'

             }}
           >
            <InfoIcon
              sx={{
                backgroundColor: `#DC2600`,
                color: "white",
                width: 32,
                height: 32,
                padding: 0.5,
                borderRadius: "10px",
              }}
             />
             <Typography variant="body2" fontWeight={600} paddingLeft={"8px"} >
                {t("cancelled")}
             </Typography>
           </Box>
            }
              <Typography variant="h6" color="text.secondary">
                Recolha
              </Typography>
              <Box sx={{ width: 1, display: "flex", alignItems: "center" }}>
                <CalendarMonthOutlinedIcon />
                <Typography
                  variant="body2"
                  sx={{ ml: 2 }}
                  textTransform={"capitalize"}
                >
                  {t("in")}{" "}
                  <span>
                    {new Date(
                      item?.donation.availableFromDate
                    ).toLocaleString("pt-PT", {
                      day: "numeric",
                      month: "numeric",
                      year: "numeric",
                      hour: "numeric",
                      minute: "numeric",
                      formatMatcher: "best fit",
                    })}
                  </span>{" "}
                  {t("until")}{" "}
                  <span>
                    {new Date(item?.donation.expiryDate).toLocaleString(
                      "pt-PT",
                      {
                        day: "numeric",
                        month: "numeric",
                        year: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                        formatMatcher: "best fit",
                      }
                    )}
                  </span>
                </Typography>
                </Box>
                {/* start Alimentação animal */}
              { isCAActive == true && item?.donation?.consumeByDate && (
                <>
                <Typography variant="h6" color="text.secondary" sx={{mt:3}}>
                  Recolha do canal alternativo
                </Typography>
                 
                  <Box sx={{ width: 1, display: "flex", alignItems: "center" }}>
                  <CalendarMonthOutlinedIcon />
                    <Typography
                      variant="body2"
                      sx={{ ml: 2 }}
                      textTransform={"capitalize"}
                    >
                      {t("in")}{" "}
                      <span>
                        {new Date(item?.donation.expiryDate).toLocaleString("pt-PT", {
                          day: "numeric",
                          month: "numeric",
                          year: "numeric",
                          hour: "numeric",
                          minute: "numeric",
                          formatMatcher: "best fit",
                        })}
                      </span>{" "}
                      {t("until")}{" "}
                      <span>
                        {new Date(item?.donation.consumeByDate).toLocaleString(
                          "pt-PT",
                          {
                            day: "numeric",
                            month: "numeric",
                            year: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                            formatMatcher: "best fit",
                          }
                        )}
                      </span>
                    </Typography>
                  </Box>
                </>
              )}
              {/* end Alimentação animal */}
              <Box
                sx={{
                  width: 1,
                  display: "flex",
                  alignItems: "flex-start",
                  mt: 2,
                  justifyContent: "space-between",
                }}
              >
               
                <Box sx={{ display: "flex" }}>
                  <LocationOnOutlinedIcon />
                  <Stack direction={"column"} ml={2}>
                    {/* <Typography>
                     
                        {item?.addresses != undefined && item?.addresses != null &&
                        item?.addresses[0].isHeadquarter == false ?
                        item?.addresses[0].entityName :
                        item?.entityLeastDetails?.entityName != null ? item?.entityLeastDetails?.entityName : entity?.entityName}
                    </Typography> */}
                    <Typography>{item?.addresses[0]?.addressLine}</Typography>
                    <Typography>{item?.addresses[0]?.district}</Typography>
                    <Typography>{item?.addresses[0]?.county}</Typography>
                    <Typography>{item?.addresses[0]?.subDivision}</Typography>
                    <Typography>{item?.addresses[0]?.postalCode}</Typography>
                    <Typography>{item?.addresses[0]?.locality}</Typography>
                    <Typography
                      color="primary"
                      sx={{ textDecoration: "underline" }}
                    >
                      {item?.addresses[0]?.latitude},
                      {item?.addresses[0]?.longitude}
                    </Typography>
                  </Stack>
                </Box>
                <Button
                  variant="outlined"
                  endIcon={
                    <DirectionsOutlinedIcon sx={{ color: "text.primary" }} />
                  }
                  size={"large"}
                  onClick={() => setMapOpen(true)}
                  sx={{
                    color: "text.secondary",
                    borderRaidus: 0,
                    background: "#e1efb0",
                    borderRadius: "4px",
                  }}
                >
                  {distance.toFixed(2)} km
                </Button>
              </Box>
            </Box>
            <Divider sx={{ my: 1 }} />
            {item.donation.isEvent == true &&
             <Box sx={{ p: 2 }}>
             <Typography
                 variant="h6"
                 color="text.secondary"
                
               >
                 {"Produtos eventualmente disponíveis"}
               </Typography>
               
               <Box sx={{ display: "block", alignItems: "center" }}>
             
               <CollectionProductsEventos
                products={item?.donation.eventProductsInformation != null ? item?.donation.eventProductsInformation.split(";") : []}
                t={t}
                collectionProduct={collectionProduct}
                setCollection={setCollection}
                setProductError={setProductError}
                componentType={ComponentType.DISTRIBUTOR_DONATION_PRODUCT}
              />
                
              </Box>
             </Box>
            }
           
            <Box sx={{ p: 2 }}>
              <Typography
                variant="h6"
                color="text.secondary"
                textTransform={"capitalize"}
              >
                {t("observations")}
              </Typography>
              <Typography variant="body1">
                {item?.donation.note ? item?.donation.note : "Sem observações"}
              </Typography>
            </Box>
            
            {item?.donation.isEvent == false &&
             <Divider sx={{ my: 1 }} /> &&
            <Box sx={{ p: 2 }}>
              <Typography
                variant="h6"
                color="text.secondary"
                textTransform={"capitalize"}
                gutterBottom
              >
                {t("Articles")}
              </Typography>
              {selectProductError && (
                <Typography
                  variant="body1"
                  color="error"
                  textTransform={"capitalize"}
                  gutterBottom
                >
                  {t("collectionSelectProductError")}
                </Typography>
              )}
              <CollectionProducts
                products={item?.donationProducts}
                t={t}
                collectionProduct={collectionProduct}
                setCollection={setCollection}
                setProductError={setProductError}
                componentType={ComponentType.DISTRIBUTOR_DONATION_PRODUCT}
              />
            </Box>
            }
            <Divider sx={{ my: 1 }} />
            {(item?.donation.status === DonationStatus.new ||
              item?.donation.status === DonationStatus.partial ||
              item?.donation.isEvent) &&
              ((isAvailableFprSpecialReceiver &&
                entity?.entityType === EntityType.specialDistributor) ||
                entity?.entityType === EntityType.distributor ||
                entity?.entityType === EntityType.donorDistributor) &&
              entity?.entityId != item?.donation.createdBy  && (
                // Lógica para filho
                (entity?.isGroupEntity && !entity?.isParentEntity && entity?.entityId === userId) ||
                // Lógica para neto
                (!entity?.isGroupEntity && !entity?.isParentEntity && entity?.entityId !== userId) ||
                //Pai sem filhos
                (!entity?.isGroupEntity && !entity?.isParentEntity && entity?.entityId == userId)
              ) && (
                <>
                  <Box sx={{ p: 2 }}>
                    <Typography
                      variant="h6"
                      color="text.secondary"
                      // textTransform={"capitalize"}
                      gutterBottom
                    >
                      {t("collectionDate")}
                    </Typography>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale={"pt"}
                      localeText={{
                        cancelButtonLabel: t("cancel"),
                      }}
                    >
                       
                       <DateTimePicker
                         dayOfWeekFormatter={(day) => {
                            const map = {
                              "2ª": "S",  // Segunda
                              "3ª": "T",  // Terça
                              "4ª": "Q",  // Quarta
                              "5ª": "Q",  // Quinta
                              "6ª": "S",  // Sexta
                              "Sa": "S",  // Sábado
                              "Do": "D",  // Domingo
                            };
                            return map[day] ?? day;
                          }}
                          value={dateWithInitialValue}
                          onChange={(newValue) => {
                            if(newValue != null){
                              if(newValue.$D){
                                if (
                                  new Date(newValue).getTime() > new Date().getTime()
                                ) {
                                  setDateWithInitialValue(
                                    toLocalISOString(new Date(newValue))
                                  );
                                  setCurrentError(null);
                                  setErrorDate(false);
                                } else {
                                  setDateWithInitialValue(
                                    toLocalISOString(new Date(newValue))
                                  );
                                  setCurrentError(t("validDate"));
                                  setErrorDate(true);
                                }
                              }else{
                                setCurrentError(t("validDate"));
                                setErrorDate(true);
                              }
                            }else{
                              setCurrentError(t("validDate"));
                              setErrorDate(true);
                            }
                            
                          }}
                          label={t("withdrawalDate")}

                          onError={(reason, value) => {
                            if (reason) {
                              setCurrentError(
                                reason === "maxDate"
                                  ? "Donation is expired"
                                  : reason
                              );
                              setErrorDate(true);
                            } else {
                              setCurrentError(null);
                              setErrorDate(false);
                            }
                          }}
                          //disablePast
                          minDateTime={dayjs(
                            new Date(item?.donation.availableFromDate)
                          )}
                          maxDateTime={
                            item?.donation.isAnimal &&
                            entity?.entityType === EntityType.specialDistributor
                              ? dayjs(
                                  new Date(item?.donation.consumeByDate)
                                )
                              : dayjs(new Date(item?.donation.expiryDate))
                          }
                          disabled = {item?.donation.isEvent == false && !collectionProduct.length}

                          //{...(collectionProduct.length == 0 && {sx: {cursor: "not-allowed" }})}
                          inputFormat="DD/MM/YYYY HH:mm"

                          renderInput={(params) => (
                          <Tooltip title = {(collectionProduct.length == 0 && item?.donation.isEvent == false ? "Selecione pelo menos um artigo para reservar" : "")} >
                            <TextField
                              {...params}
                              // size="small"
                              error={errorDate}
                              helperText={currentError ?? currentError}
                            />
                            </Tooltip>
                          )}

                          />

                    </LocalizationProvider>
                  </Box>{" "}
                  <Box
                    sx={{
                      // position: "absolute",
                      // bottom: "0px",
                      padding: "20px",
                      // width: "97%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignContent: "center",
                      background: "#fff",
                    }}
                  >
                    <Tooltip
                      title={"Limpar campos"}
                      arrow
                      
                    >
                      <Button
                      sx={{
                        bgcolor: "#EEEEEE",
                        width: "170px",
                        height: "38px",
                        borderRadius: "4px",
                      }}
                      onClick={() => clearCollectionProduct()}
                    >
                      <SvgIconStyle
                        src="/static/dashboard/lock.svg"
                        sx={{ color: "black", width: "20px", height: "20px" , marginRight: "10px" }}
                      />
                      <span style={{ color: "black", fontSize: "14px" }}>Limpar campos</span>
                    </Button>
                    </Tooltip>
                    
                    <Button
                      size="large"
                      variant="contained"
                      onClick={submitCollection}
                      startIcon={
                        <AssignmentTurnedInOutlinedIcon fontSize="16px" />
                      }
                      disabled={
                        (item?.donation.status === DonationStatus.reserved &&
                          !item?.donation.isEvent) ||
                        status === RegistrationStatus.inActive ||
                        status === RegistrationStatus.inAtivo ||
                        status === RegistrationStatus.revoked
                      }
                      sx={{ borderRadius: "4px" }}
                    >
                      <Typography variant="bold">{t("approve")}</Typography>
                    </Button>
                  </Box>{" "}
                </>
              )}
          </>
        )}
        {mapOpen && (
          <Box sx={{ width: 1, height: 1 }}>
            <MapLeaflet
              isDirectionAble={true}
              position={position}
              setPosition={setMarkPosition}
              sourceAddress={address[0]}
              destinationAdrress={item.addresses[0]}
              t={t}
            />
          </Box>
        )}
      </Drawer>
    </React.Fragment>
  );
};

export default CollectionDonationCard;
